<template>
  <v-card>
    <v-card-text class="pa-0">
      <template>
        <v-toolbar card color="white">
          <v-text-field
            flat
            solo
            prepend-icon="search"
            placeholder="Filtrar"
            v-model="search"
            hide-details
            class="hidden-sm-and-down"
          ></v-text-field>
          <router-link :to="{ name: 'cadastro-funcionario' }" class="nounderline">
            <v-btn icon>
              <v-icon>add_circle_outline</v-icon>
            </v-btn>
          </router-link>
        </v-toolbar>
        <v-divider></v-divider>
        <v-data-table :headers="headers" :search="search" :items="funcionario" hide-actions class="elevation-0">
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.nome }}</td>
            <td>{{ props.item.telefone1 }}</td>
            <td>{{ props.item.dataNasc }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.nomeCargo }}</td>
            <td class="text-xs-right">
              <router-link :to="{ name: 'edit-funcionario', params: { id: props.item.id } }" class="nounderline">
                <v-btn depressed icon dark color="primary" small>
                  <v-icon small>edit</v-icon>
                </v-btn>
              </router-link>
              <router-link :to="{ name: 'view-funcionario', params: { id: props.item.id } }" class="nounderline">
                <v-btn depressed icon dark color="primary" small>
                  <v-icon small>remove_red_eye</v-icon>
                </v-btn>
              </router-link>
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import { ServicoFuncionario } from "../../servicos/servicoFuncionario"
const servicoFuncionario = new ServicoFuncionario()
export default {
  data() {
    return {
      search: "",
      funcionario: [],
      headers: [
        {
          text: "Código",
          align: "left",
          value: "Id"
        },
        { text: "Nome", align: "left", value: "nome" },
        { text: "Telefone", align: "left", value: "telefone1" },
        { text: "Nascimento", align: "left", value: "dataNasc" },
        { text: "E-mail", align: "left", value: "email" },
        { text: "Cargo", align: "left", value: "nomeCargo" },
        { text: "", value: "action", align: "right" }
      ]
    }
  },
  created() {
    servicoFuncionario.buscarFuncionario().then(
      res => {
        if (res.status === 200) {
          this.funcionario = res.data
        }
      },
      // eslint-disable-next-line
      err => console.log(err)
    )
  }
}
</script>
<style>
a.nounderline:link {
  text-decoration: none;
}
</style>
